export function submitWithInteractionEvent<Args extends unknown[], Result>(
  eventRef: {current: Event | undefined},
  event: Event,
  submit: (...args: Args) => Result,
  ...args: Args
): Result {
  const previous = eventRef.current
  eventRef.current = event
  try {
    // The submit handler captures this event before its first await.
    return submit(...args)
  } finally {
    eventRef.current = previous
  }
}
